export default {
  props: {
    visible: {
      type: Boolean,
    }
  },
  methods: {
    handleSubmit() {
    },
    handleClose() {
      this.$emit('update:visible', false);
    }
  },
};
